export const FileViews = {
  mobile: 'mobile',
  desktop: 'desktop',
};

export default FileViews;
